import { RequestAccessCardCancellation } from './request-access-card-cancellation';

export class RequestAccessCardCancellationExport {
  Company_Name: string;
  Request_number: string;
  Request_Date: Date;
  Request_Type: string;
  Request_Status: string;
  Requestor_Name: string;
  On_Behalf_Of: string;
  Badge_Number: string;
  Cancellation_Reason: string;
  Access_Card_Type: string;
  End_Date: Date;

  constructor(request: RequestAccessCardCancellation) {
    this.Company_Name = request.companyName;
    this.Request_number = request.requestNumber;
    this.Request_Date = request.requestDate;
    this.Request_Type = request.requestTypeName;
    this.Request_Status = request.requestStatusName;
    this.Requestor_Name = request.requestorName;
    this.On_Behalf_Of = request.onBehalfName;
    this.Badge_Number = request.badgeNumber;
    this.Cancellation_Reason = request.requestAccessCardCancellationReasonName;
    this.Access_Card_Type = request.accessCardTypeName;
    this.End_Date = request.endDate;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/request-access-card-cancellation-export.ts